import { render, staticRenderFns } from "./NOM.vue?vue&type=template&id=b3b993b4"
import script from "./NOM.vue?vue&type=script&lang=js"
export * from "./NOM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports